import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetDevolucoesVendaResponse } from '../../responses/vendas/devolucoes-venda.response';
import { DevolucoesVendaRequest } from '../../requests/vendas/devolucoes-venda.request';

@Injectable({
    providedIn: 'root',
})
export class DevolucoesVendaService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'DevolucoesVenda';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<GetDevolucoesVendaResponse> {
        return this.httpClient
            .get<GetDevolucoesVendaResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: DevolucoesVendaRequest): Observable<GetDevolucoesVendaResponse> {
        const url = `${this.apiUrl}/idDevolucoesVenda/${id}`;
        return this.httpClient
            .put<GetDevolucoesVendaResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
